// extracted by mini-css-extract-plugin
export var button = "styles-module--button--VbvcY";
export var buttonBlack = "styles-module--buttonBlack--usut9";
export var buttonWhite = "styles-module--buttonWhite--5UlQO";
export var button__innerContent = "styles-module--button__innerContent--gA9OZ";
export var transparent = "styles-module--transparent--PLKiA";